import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { GenericResponse, Sezionale } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';


interface ItemSezionale {
  modify : boolean,
  item : Sezionale
}
@Component({
  selector: 'app-sectionals',
  templateUrl: './sectionals.component.html',
  styleUrls: ['./sectionals.component.css']
})


export class SectionalsComponent implements OnInit {

  me : UserInfo | undefined;
  @Input() userId : string | number | undefined;

  sectionals : ItemSezionale[] = [];

  constructor(private configService : ConfigurationService, private loginService : LoginService, private translate : TranslateService,
      private modalService : ModalServiceService, private toastService: ToastService) { }

  async ngOnInit() {
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");
    let resSez = (await this.configService.getSezionali(this.userId!));
    if (resSez) {
      let list = resSez.data;
      if(Array.isArray(list)) {
        list.forEach((item : Sezionale) => this.sectionals.push({modify : false, item : item}))
      }
    } else {
      this.toastService.openToast("Errore!", "warning");
    }
    
  }

  async deleteItem(sectional : ItemSezionale) {
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.delete");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.delete");
    
    let response : GenericResponse;
    if (sectional.item.id=='') {
      this.sectionals.pop();
    } else {
      let check = await this.modalService.openConfirm(label, message);
      if(check) {
        response = await this.configService.deleteSezionale(this.userId!, sectional.item.id);
        if(response.success) {
          this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.delete.success"), "success");  
        } else {
          this.toastService.openToast(response.msg, "warning");
        }
      this.refresh();
      } 
    }
    

  }

  modifyItem(sectional : ItemSezionale) {
    sectional.modify = true;
  }

  addSectional() {
    if(this.sectionals.filter(e => e.item.id=='').length==0) {
      let newSec : ItemSezionale = {
        modify : true,
        item : {
          id: '',
          user_id : this.userId!,
          numerazione : '',
          sezionale : ''
        }
      }
      this.sectionals.push(newSec);
    }
    
  }

  async refresh() {
    this.sectionals = [];
    let list = (await this.configService.getSezionali(this.userId!)).data;
    list.forEach((item : Sezionale) => this.sectionals.push({modify : false, item : item}))
  }

  async save(sectional : ItemSezionale) {
    //console.log(sectional);
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
    let check = await this.modalService.openConfirm(label, message);
    let response : GenericResponse;
    //if(sectional.item.numerazione!='' && sectional.item.sezionale!='' && check) {
    if(sectional.item.numerazione!='' && check) {
      if(sectional.item.id == "")
        response = await this.configService.saveSezionaleConf(this.userId!, sectional.item);
      else 
        response = await this.configService.saveSezionale(this.userId!, sectional.item);
      if(response.success) {
        this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success");
      } else {
        this.toastService.openToast(response.msg, "warning");
      }
      this.refresh();

    } else {
      if(check) {
        this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate, 'toast.save.warning'), "warning");
      }
    }
    
  }
  

}
